module.exports = __webpack_public_path__ + "cadaf73716ae5b4a6b82d9855c04c525.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-26@2x.png
// module id = 509
// module chunks = 0